import { GetDomElementOuterWidth, SetDomElementOuterHeight, SetDomElementOuterWidth } from '../engine/viewer/domutils.js';
import { PanelSet } from './panelset.js';
import { SidebarDetailsPanel } from './sidebardetailspanel.js';
import { SidebarSettingsPanel } from './sidebarsettingspanel.js';
import { SidebarCommentsPanel } from './sidebarcommentspanel.js';

import { debugLog } from '../../tools/debug.js';

export class Sidebar
{
    constructor (mainDiv, settings, apiConfig, globalCommentsManager = null)
    {
        debugLog('Sidebar constructor');
        this.mainDiv = mainDiv;
        this.panelSet = new PanelSet (mainDiv);
        this.globalCommentsManager = globalCommentsManager;

        this.detailsPanel = new SidebarDetailsPanel (this.panelSet.GetContentDiv ());
        this.settingsPanel = new SidebarSettingsPanel (this.panelSet.GetContentDiv (), settings);
        this.commentsPanel = new SidebarCommentsPanel (this.panelSet.GetContentDiv (), apiConfig, globalCommentsManager);
        debugLog('CommentsPanel', this.commentsPanel);


        this.panelSet.AddPanel (this.detailsPanel);
        this.panelSet.AddPanel (this.settingsPanel);
        this.panelSet.AddPanel (this.commentsPanel);
        debugLog('Added comment panel');
        // this.panelSet.ShowPanel (this.detailsPanel);
        this.panelSet.ShowPanel(this.commentsPanel);
    }

    IsPanelsVisible ()
    {
        return this.panelSet.IsPanelsVisible ();
    }

    ShowPanels (show)
    {
        this.panelSet.ShowPanels (show);
    }

    Init (callbacks)
    {
        this.callbacks = callbacks;

        this.panelSet.Init ({
            onResizeRequested : () => {
                this.callbacks.onResizeRequested ();
            },
            onShowHidePanels : (show) => {
                this.callbacks.onShowHidePanels (show);
            }
        });

        this.settingsPanel.Init ({
            getShadingType : () => {
                return this.callbacks.getShadingType ();
            },
            getProjectionMode : () => {
                return this.callbacks.getProjectionMode ();
            },
            getDefaultMaterials : () => {
                return this.callbacks.getDefaultMaterials ();
            },
            onEnvironmentMapChanged : () => {
                this.callbacks.onEnvironmentMapChanged ();
            },
            onBackgroundColorChanged : () => {
                this.callbacks.onBackgroundColorChanged ();
            },
            onDefaultColorChanged : () => {
                this.callbacks.onDefaultColorChanged ();
            },
            onEdgeDisplayChanged : () => {
                this.callbacks.onEdgeDisplayChanged ();
            }
        });

        this.commentsPanel.Init ({
            onCadReferenceClick : (cadReference) => {
                if (this.callbacks.onCadReferenceClick) {
                    this.callbacks.onCadReferenceClick (cadReference);
                }
            }
        });
    }

    UpdateControlsStatus ()
    {
        this.settingsPanel.UpdateControlsStatus ();
    }

    UpdateControlsVisibility ()
    {
        this.settingsPanel.UpdateControlsVisibility ();
    }

    Resize (height)
    {
        SetDomElementOuterHeight (this.mainDiv, height);
        this.panelSet.Resize ();
        this.commentsPanel.Resize ();
    }

    GetWidth ()
    {
        return GetDomElementOuterWidth (this.mainDiv);
    }

    SetWidth (width)
    {
        SetDomElementOuterWidth (this.mainDiv, width);
    }

    Clear ()
    {
        this.panelSet.Clear ();
    }

    AddObject3DProperties (model, object3D)
    {
        this.detailsPanel.AddObject3DProperties (model, object3D);
    }

    AddMaterialProperties (material)
    {
        this.detailsPanel.AddMaterialProperties (material);
    }

    // Comments panel methods
    GetCommentsPanel ()
    {
        return this.commentsPanel;
    }

    ShowCommentsPanel ()
    {
        this.panelSet.ShowPanel (this.commentsPanel);
    }

    AddComment (message, cadReference = null)
    {
        this.commentsPanel.addComment (message, cadReference);
    }

    GetCommentsForCadElement (elementId)
    {
        return this.commentsPanel.getCommentsForCadElement (elementId);
    }

    HighlightCommentsForCadElement (elementId)
    {
        this.commentsPanel.highlightCommentsForCadElement (elementId);
    }

    // Export/import comments for persistence
    ExportComments ()
    {
        return this.commentsPanel.exportComments ();
    }

    ImportComments (data)
    {
        this.commentsPanel.importComments (data);
    }
}
